













import VueOptions from '@utils/VueOptions'

settings =
  name: 'ImpersonateMenu'
  vue:
    store: ['cookie', 'member', 'originalMember']

    computed:
      isImpersonating: ->
        @cookie?.originalMemberToken?

      memberName: ->
        return @member.email unless @member.first_name || @member.last_name
        [@member.first_name, @member.last_name].join(' ')

    methods:
      hiDropdownItemClick: (command) ->
        switch command
          when 'exit'
            { lastUrl } = @originalMember
            @stopImpersonating()
            window.location.href = lastUrl || window.location.origin

export default VueOptions.vue settings
